import { render, staticRenderFns } from "./ComHeaderTwo.vue?vue&type=template&id=f1ca28dc&scoped=true"
import script from "./ComHeaderTwo.vue?vue&type=script&lang=js"
export * from "./ComHeaderTwo.vue?vue&type=script&lang=js"
import style0 from "./ComHeaderTwo.vue?vue&type=style&index=0&id=f1ca28dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca28dc",
  null
  
)

export default component.exports